import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { resetPassword } from "../data/repository";

function PasswordReset() {

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [newPassword, setNewPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setNewPassword("");
        setIsSubmitting(true);

        try {
            await resetPassword(token, newPassword);
            setSuccessMessage('Password reset successfully');
            setIsSubmitting(false);
        } catch (error) {
            setIsSubmitting(false);
            setErrorMessage('Failed to reset password! Invalid or expired token!');
        }
    };


    return (
        <div>
            <h2 className="text-center mb-3" style={{ padding: "50px 20px 0 20px", color: "#112c3f" }}>Reset Password</h2>

            <form className="login-form" style={{ maxWidth: "400px", margin: "0 auto" }} onSubmit={handlePasswordReset}>
                <div className="form-group">
                    <label className="text-center" htmlFor="newPassword">New Password:</label>
                    <input className="form-control" type="password" id="newPassword" name="newPassword" onChange={(e) => setNewPassword(e.target.value)} required />
                </div>

                <div className="text-center">
                    {!isSubmitting && <button className="btn btn-custom" type="submit">Reset Password</button>}
                    {isSubmitting && <em style={{}}>Please Wait - Resetting Password...</em>}
                </div>

                {successMessage && <div className="alert alert-success text-center" style={{ margin: "20px" }}>{successMessage}</div>}
                {errorMessage && <div className="alert alert-danger text-center" style={{ margin: "20px" }}>{errorMessage}</div>}

            </form>
        </div>

    );
}

export default PasswordReset;